import {neverland as $, html} from 'neverland';
import { setupMFA, verifyMFASetup } from '../lib/cognito.js';

const MFASetupPage = $(function({auth, setAuth}) {

  async function initiateMFASetup() {
    try {
      document.getElementById('error-message').style.display = 'none';
      
      const result = await setupMFA(auth.cognitoUser);
      
      if (result.secretCode) {
        // Hide setup section and show verify section
        document.getElementById('mfa-setup-section').style.display = 'none';
        document.getElementById('mfa-verify-section').style.display = 'block';
        
        // Set the secret code and QR code
        document.getElementById('secret-code').textContent = result.secretCode;
        
        const appName = 'Resilient Youth Admin';
        const userEmail = auth.userEmail || 'user@example.com';
        const qrUrl = `otpauth://totp/${encodeURIComponent(appName)}:${encodeURIComponent(userEmail)}?secret=${result.secretCode}&issuer=${encodeURIComponent(appName)}`;
        
        document.getElementById('qr-code').src = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(qrUrl)}`;
      }
    } catch (err) {
      document.getElementById('error-message').textContent = `Failed to setup MFA: ${err.message || err}`;
      document.getElementById('error-message').style.display = 'block';
    }
  }

  async function verifySetup() {
    const totpCode = document.getElementById('totp-code').value;
    
    if (!totpCode || totpCode.length !== 6) {
      document.getElementById('error-message').textContent = 'Please enter a valid 6-digit code';
      document.getElementById('error-message').style.display = 'block';
      return;
    }

    try {
      document.getElementById('error-message').style.display = 'none';
      await verifyMFASetup(auth.cognitoUser, totpCode);
      
      // MFA setup complete, log user in
      setAuth(prevAuth => ({
        ...prevAuth,
        publicPage: null,
        isLoggedIn: true,
        currentUser: auth.cognitoUser
      }));
    } catch (err) {
      document.getElementById('error-message').textContent = 'Invalid code. Please try again.';
      document.getElementById('error-message').style.display = 'block';
    }
  }

  function handleKeyPress(event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      verifySetup();
    }
  }

  return html`
    <div class="mfa-setup">
      <div id="mfa-setup-section">
        <h2>Setup Multi-Factor Authentication</h2>
        <p>For security, you must setup multi-factor authentication on your first login.</p>
        <p>You'll need an authenticator app like Google Authenticator, Authy, or Microsoft Authenticator.</p>

        
        <button onclick="${initiateMFASetup}" class="setup-button">Setup MFA</button>
        
        <div id="error-message" class="error" style="display: none;"></div>
      </div>
      
      <div id="mfa-verify-section" style="display: none;">
        <h2>Configure Your Authenticator App</h2>
        
        <div class="setup-instructions">
          <h3>Step 1: Scan QR Code</h3>
          <p>Open your authenticator app and scan this QR code:</p>
          <img id="qr-code" alt="QR Code for MFA setup" class="qr-code" />
          
          <h3>Step 2: Manual Entry (if needed)</h3>
          <p>If you can't scan the QR code, manually enter this secret:</p>
          <code id="secret-code" class="secret-code"></code>
          
          <h3>Step 3: Enter Verification Code</h3>
          <p>Enter the 6-digit code from your authenticator app:</p>
          <input 
            id="totp-code" 
            type="text" 
            maxlength="6" 
            placeholder="000000"
            onkeyup="${handleKeyPress}"
          />
          
          <button onclick="${verifySetup}" class="verify-button">Verify & Complete Setup</button>
        </div>
      </div>
    </div>
  `;
});

export default MFASetupPage;